<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="organizations">
    <v-row>
      <v-col col="12" class="d-md-flex justify-md-space-between align-center">
        <h1>{{ $t("organizations") }}</h1>
      </v-col>
      <v-col class="filter-box d-flex justify-end" cols="12" md="6">
        <div class="btn-box">
          <v-btn
            @click.stop="newOrganization"
            :disabled="isDisabledCreate()"
            class="btn-two mobile-block mr-0 mr-sm-6"
            color="#08a657"
            height="56px"
            text
          >
            <v-icon>mdi-plus</v-icon>
            {{ $t("organization.create_organization") }}
          </v-btn>
          <v-btn
            class="bg-white btn-two mobile-bloc"
            color="#e3e9ed"
            height="56px"
            text
            outlined
            @click="showSearchRow"
          >
            <v-icon class="ma-0" color="#4f526c">mdi-magnify</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col col="12">
        <v-expand-transition>
          <v-row class="transition-display brd-top-vone" v-show="showSearch">
            <v-col cols="12" md="6" lg="8">
              <v-text-field
                :placeholder="$t('crm.search')"
                outlined
                hide-details
                v-model="searchText"
                background-color="#fff"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                height="56px"
                class="btn-one"
                block
                text
                depressed
                @click="hideFilter"
              >
                <span>{{ $t("cancel") }}</span>
              </v-btn>
            </v-col>
            <v-col cols="12" md="3" lg="2">
              <v-btn
                class="btn-two"
                color="#08a657"
                height="56px"
                block
                depressed
                dark
                @click="search"
              >
                <span>{{ $t("search") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-card>
          <v-data-table
            :headers="headers"
            :items="organizationsData"
            class="elevation-1"
            :options.sync="options"
            :items-per-page="options.rowsPerPageItems"
            :server-items-length="totalItems"
            :loading="this.$store.state.loading"
            :footer-props="{
              'items-per-page-options': this.$store.state.rowsPerPageItems,
              'items-per-page-text': $t('rowsPerPage'),
            }"
            :no-data-text="$t('noDataAvailable')"
          >
            <template v-slot:item.organizationType="{ item }">
              <span v-if="item.organizationType === 1">{{
                $t("organization.customer")
              }}</span>
              <span v-if="item.organizationType === 2">{{
                $t("organization.transport_company")
              }}</span>
              <span v-if="item.organizationType === 3">{{
                $t("organization.management_company")
              }}</span>
              <span v-if="item.organizationType === 4">{{
                $t("organization.government_authority")
              }}</span>
              <span v-if="item.organizationType === 5">{{
                $t("organization.sender_receiver_transport")
              }}</span>
            </template>
            <template v-slot:item.edit="{ item }">
              <v-btn fab small color="#fff" :disabled="isDisabledDeleteEdit()">
                <v-icon color="#5b8ff5" @click="editItem(item)">
                  mdi-pencil-outline
                </v-icon>
              </v-btn>
            </template>
            <template v-slot:item.delete="{ item }">
              <v-btn fab small color="#fff" :disabled="isDisabledDeleteEdit()">
                <v-icon color="#5b8ff5" @click="deleteItem(item)">
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $t("organization.delete_organization")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="warning">
            {{ $t("organization.delete_warning_message") }}
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            {{ $t("cancel") }}
          </v-btn>

          <v-btn color="green darken-1" text @click="removeItem()">
            {{ $t("crm.delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogOrganization" persistent max-width="1000px">
      <v-card>
        <v-container style="max-width: 1000px">
          <v-card-title class="headline lighten-2" primary-title>
            {{ formTitle }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form
              ref="formOrganization"
              v-model="formOrganizationValid"
              lazy-validation
            >
              <v-tabs v-model="tab" center-active>
                <v-tab>{{ $t("organization.generalOptions") }}</v-tab>
                <v-tab>{{ $t("organization.webhookSettings") }}</v-tab>
                <v-tab v-if="payloadOrganization.exceptionRegistrationSign">
                  {{ $t("organization.exceptionOptions") }}
                </v-tab>
                <v-tab v-if="payloadOrganization.issuingOrganization">
                  {{ $t("organization.manualCreationE-CMR") }}
                </v-tab>
                <v-tab v-if="!isGovernment">{{
                  $t("organization.emailOptions")
                }}</v-tab>
                <v-tab v-if="editedId !== -1">{{
                  $t("organization.attachedFiles")
                }}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-text-field
                          v-model="payloadOrganization.name"
                          :rules="[(v) => !!v || $t('field_is_required')]"
                          :label="$t('organization.name')"
                          required
                          outlined
                          :disabled="!payloadOrganization.canChangeSign"
                        ></v-text-field>
                        <v-text-field
                          v-model="payloadOrganization.carrierCode"
                          :label="$t('organization.carrier_code')"
                          outlined
                          :disabled="!payloadOrganization.canChangeSign"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        v-if="payloadOrganization.organizationType !== 3"
                        class="py-0"
                        cols="12"
                      >
                        <v-autocomplete
                          :items="parentOrgItems"
                          :label="$t('organization.parent_organization')"
                          item-text="name"
                          item-value="id"
                          v-model="payloadOrganization.organizationId"
                          outlined
                          required
                          :rules="[(v) => !!v || $t('field_is_required')]"
                          :no-data-text="$t('noDataAvailable')"
                          :loading="parentOrgLoading"
                          :search-input.sync="parentOrgSearch"
                          :filter="parentOrgNoFilter"
                          @focus="onParentOrgOpen"
                          @click:clear="onParentOrgClear"
                          :cache-items="false"
                          :hide-no-data="parentOrgLoading"
                          clearable
                        >
                          <template v-slot:item="data">
                            <div>
                              <div>
                                <b>{{ data.item.name }}</b>
                              </div>
                              <div>
                                <span v-if="data.item.street">{{
                                  data.item.street
                                }}</span>
                                <span v-if="data.item.postalCode"
                                  >, {{ data.item.postalCode }}</span
                                >
                                <span v-if="data.item.place"
                                  >, {{ data.item.place }}</span
                                >
                                <span v-if="data.item.countryCode"
                                  >, {{ data.item.countryCode }}</span
                                >
                              </div>
                            </div>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0" cols="12" md="6">
                        <v-text-field
                          v-model="payloadOrganization.postalCode"
                          :label="$t('organization.postal_code')"
                          outlined
                          :disabled="!payloadOrganization.canChangeSign"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12" md="6">
                        <v-autocomplete
                          :items="countryCodes"
                          :label="$t('organization.country_code')"
                          :item-text="
                            (data) => data.codeName + ' - ' + data.value
                          "
                          item-value="value"
                          v-model="payloadOrganization.countryCode"
                          outlined
                          required
                          :rules="[(v) => !!v || $t('field_is_required')]"
                          :no-data-text="$t('noDataAvailable')"
                          :disabled="!payloadOrganization.canChangeSign"
                        >
                        </v-autocomplete>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-text-field
                          v-model="payloadOrganization.place"
                          :label="$t('organization.place')"
                          outlined
                          :disabled="!payloadOrganization.canChangeSign"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12" md="9">
                        <v-text-field
                          v-model="payloadOrganization.street"
                          :label="$t('organization.street')"
                          outlined
                          :disabled="!payloadOrganization.canChangeSign"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-autocomplete
                          v-model="payloadOrganization.organizationType"
                          :items="organizationType"
                          item-text="name"
                          item-value="value"
                          menu-props="auto"
                          :label="$t('organization.organization_type')"
                          outlined
                          required
                          :rules="[(v) => !!v || $t('field_is_required')]"
                          :no-data-text="$t('noDataAvailable')"
                          :disabled="
                            payloadOrganization.organizationType === 3 ||
                              !payloadOrganization.canChangeSign
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-text-field
                          v-model="payloadOrganization.vat"
                          :label="$t('organization.vat')"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-text-field
                          v-model="payloadOrganization.duns"
                          :label="$t('organization.duns')"
                          outlined
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-text-field
                          v-model="payloadOrganization.ean"
                          :label="$t('organization.ean')"
                          outlined
                          counter="13"
                          maxlength="13"
                        ></v-text-field>
                      </v-col>

                      <v-col
                        class="py-0"
                        cols="12"
                        v-if="
                          payloadOrganization.organizationType === 1 ||
                            payloadOrganization.organizationType === 2 ||
                            payloadOrganization.organizationType === 5
                        "
                      >
                        <v-checkbox
                          v-model="payloadOrganization.issuingOrganization"
                          :label="$t('organization.issuingOrganization')"
                          :disabled="!payloadOrganization.id"
                          color="info"
                          inset
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        class="py-0"
                        cols="12"
                        v-if="
                          payloadOrganization.organizationType === 1 ||
                            payloadOrganization.organizationType === 2 ||
                            payloadOrganization.organizationType === 5
                        "
                      >
                        <v-checkbox
                          v-model="payloadOrganization.pdfLogRegistration"
                          :label="$t('organization.pdfLogRegistration')"
                          :disabled="!payloadOrganization.issuingOrganization"
                          color="info"
                          inset
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        class="py-0"
                        cols="12"
                        v-if="
                          payloadOrganization.organizationType === 1 ||
                            payloadOrganization.organizationType === 2 ||
                            payloadOrganization.organizationType === 5
                        "
                      >
                        <v-checkbox
                          v-model="payloadOrganization.manualCreationUseSign"
                          :label="$t('organization.useForManualCreation')"
                          :disabled="
                            !payloadOrganization.issuingOrganization &&
                              !canManualCreationUseSign
                          "
                          color="info"
                          inset
                        ></v-checkbox>
                      </v-col>

                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="
                            payloadOrganization.exceptionRegistrationSign
                          "
                          :label="$t('organization.exceptions')"
                          :disabled="!payloadOrganization.id"
                          color="info"
                          inset
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="payloadOrganization.dashboardPaymentSign"
                          :disabled="setDisabled"
                          @change="isSelected"
                          :label="$t('organization.dashboardPaymentSign')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="payloadOrganization.dashboardDisplaySign"
                          :disabled="!payloadOrganization.dashboardPaymentSign"
                          :label="$t('organization.dashboardDisplaySign')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="payloadOrganization.setLoadUnloadTimeSign"
                          :label="$t('organization.timeTracking')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="
                            payloadOrganization.barcodePalletAdditionModeSign
                          "
                          :label="$t('organization.returnGoodsScanning')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-text-field
                          v-model="payloadOrganization.palletAdditionLogEmail"
                          :label="$t('organization.returnGoodsReportingEmail')"
                          outlined
                          :hint="
                            $t('organization.returnGoodsReportingEmailInfo')
                          "
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="
                            payloadOrganization.canSignedBySubordinateSign
                          "
                          :label="$t('organization.childCanSign')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="
                            payloadOrganization.manualPickingGoodlinesSign
                          "
                          :label="$t('organization.manualPickingGoodlinesSign')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                      <v-col class="py-0" cols="12">
                        <v-checkbox
                          v-model="payloadOrganization.noTranslationOnCmrSign"
                          :label="$t('organization.noTranslationOnCmrSign')"
                          color="info"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="organization__logo" cols="3">
                        <img
                          v-if="documentFileLogo || payloadOrganization.logo"
                          :src="
                            payloadOrganization.logo
                              ? `data:image/jpeg;base64,${
                                  payloadOrganization.logo
                                }`
                              : `data:image/jpeg;base64,${documentFileLogo}`
                          "
                          alt="logo"
                        />
                      </v-col>
                      <v-col cols="9">
                        <v-file-input
                          v-model="documentFileInputLogo"
                          :placeholder="
                            $t('organization.attachedFilesUploadDocuments')
                          "
                          :label="$t('organization.attachedFilesInput')"
                        ></v-file-input>
                      </v-col>
                      <v-alert
                        v-if="documentFileErrorLogo"
                        dismissible
                        type="error"
                        color="red"
                      >
                        {{ documentFileErrorLogo }}
                      </v-alert>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-text-field
                          v-model="payloadOrganization.webhookUrl"
                          label="URL"
                          outlined
                        ></v-text-field>
                        <v-text-field
                          v-model="payloadOrganization.webhookAuthorization"
                          :label="$t('organization.authorization')"
                          :hint="$t('organization.authorizationHint')"
                          persistent-hint
                          outlined
                        ></v-text-field>

                        <v-checkbox
                          v-model="
                            payloadOrganization.webhookReadyToSigningSign
                          "
                          :label="$t('crm.status_ready_signing')"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="payloadOrganization.webhookSenderSigningSign"
                          :label="$t('organization.signedBySender')"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="payloadOrganization.webhookDriverSigningSign"
                          :label="$t('organization.signedByDriver')"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                        <v-checkbox
                          v-model="payloadOrganization.webhookClosedSign"
                          :label="$t('organization.closed')"
                          color="primary"
                          hide-details
                        ></v-checkbox>

                        <v-text-field
                          v-model="payloadOrganization.cmrModifyWebhookUrl"
                          :label="$t('organization.CMRChangeURL')"
                          disabled
                          :hint="
                            'Activate subscritpion via contactperson Collect + Go'
                          "
                          persistent-hint
                          outlined
                          class="mt-10"
                        ></v-text-field>

                        <v-text-field
                          v-model="
                            payloadOrganization.apiChangesNotificationEmail
                          "
                          :label="$t('organization.swaggerNotificationEmail')"
                          :disabled="!payloadOrganization.login"
                          persistent-hint
                          outlined
                          class="mt-5"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item
                  v-if="payloadOrganization.exceptionRegistrationSign"
                >
                  <v-container>
                    <h2
                      class="mb-5 primary--text font-weight-regular"
                      style="font-size: 23px"
                    >
                      {{ $t("organization.exceptionsList") }}
                    </h2>

                    <h3>
                      {{ $t("organization.activeExceptions") }}
                    </h3>
                    <v-subheader class="mb-3" v-if="!activeExceptions.length">
                      {{ $t("organization.activeExceptionsListEmpty") }}
                    </v-subheader>

                    <v-row v-if="activeExceptions.length" class="mb-2">
                      <v-col
                        class="pb-0"
                        cols="12"
                        v-for="(exception, index) in activeExceptions"
                        :key="exception.id"
                      >
                        <h4
                          class="font-weight-medium mb-3"
                          style="font-size: 15px"
                        >
                          {{ $t("organization.exceptionType") }}
                        </h4>
                        <div class="d-flex">
                          <v-text-field
                            v-model="exception.name"
                            :label="$t('organization.name')"
                            :error="exception.isErrorExceptionType"
                            :error-messages="
                              exception.errorExceptionTypeMessage
                            "
                            outlined
                            ref="exceptionInput"
                          ></v-text-field>
                          <div class="mt-2 ml-3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mr-2"
                                  fab
                                  depressed
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    !$isPermitted('modifyOrDeleteOrganizations')
                                  "
                                  @click="handleEditException(exception, index)"
                                >
                                  <v-icon>mdi-content-save</v-icon>
                                </v-btn>
                              </template>
                              <span>{{
                                $t("organization.saveException")
                              }}</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  class="mr-2"
                                  fab
                                  depressed
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    !$isPermitted('modifyOrDeleteOrganizations')
                                  "
                                  @click="handleDeleteException(exception)"
                                >
                                  <v-icon>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>{{
                                $t("organization.deleteException")
                              }}</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  fab
                                  depressed
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="
                                    !$isPermitted('modifyOrDeleteOrganizations')
                                  "
                                  @click="handleAddTranslations(exception)"
                                >
                                  <svg
                                    style="width: 24px; height: 24px"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      fill="currentColor"
                                      d="M11 1H3C1.9 1 1 1.9 1 3V15L4 12H9V11C9 8.8 10.79 7 13 7V3C13 1.9 12.1 1 11 1M11 4L9.5 4C9.16 5.19 8.54 6.3 7.68 7.26L7.66 7.28L8.92 8.53L8.55 9.54L7 8L4.5 10.5L3.81 9.77L6.34 7.28C5.72 6.59 5.22 5.82 4.86 5H5.85C6.16 5.6 6.54 6.17 7 6.68C7.72 5.88 8.24 4.97 8.57 4L3 4V3H6.5V2H7.5V3H11V4M21 9H13C11.9 9 11 9.9 11 11V18C11 19.1 11.9 20 13 20H20L23 23V11C23 9.9 22.1 9 21 9M19.63 19L18.78 16.75H15.22L14.38 19H12.88L16.25 10H17.75L21.13 19H19.63M17 12L18.22 15.25H15.79L17 12Z"
                                    />
                                  </svg>
                                </v-btn>
                              </template>
                              <span>{{
                                $t("organization.addTranslations")
                              }}</span>
                            </v-tooltip>
                          </div>
                        </div>

                        <div v-if="exception.translationExceptionTypes">
                          <p class="mb-3">
                            {{ $t("organization.exceptionTypeTranslations") }}
                          </p>
                          <v-col
                            class="pr-0 pt-0 pb-0 pl-10"
                            cols="12"
                            v-for="translationExceptionType in exception.translationExceptionTypes"
                            :key="translationExceptionType.id"
                          >
                            <div class="d-flex">
                              <v-text-field
                                v-model="translationExceptionType.name"
                                :label="$t('organization.nameTranslation')"
                                :error="
                                  translationExceptionType.isErrorExceptionType
                                "
                                :error-messages="
                                  translationExceptionType.errorExceptionTypeMessage
                                "
                                outlined
                                ref="exceptionInput"
                                class="ml-20"
                              >
                                <template v-slot:append>
                                  <img
                                    :src="
                                      require('../assets/' +
                                        translationExceptionType.languageCode +
                                        '.png')
                                    "
                                    :alt="translationExceptionType.languageCode"
                                  />
                                </template>
                              </v-text-field>
                              <div class="mt-2 ml-3">
                                <v-tooltip
                                  top
                                  v-if="translationExceptionType.isAdded"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      fab
                                      depressed
                                      small
                                      v-bind="attrs"
                                      v-on="on"
                                      :disabled="
                                        !$isPermitted(
                                          'modifyOrDeleteOrganizations'
                                        )
                                      "
                                      @click="
                                        handleDeleteException(
                                          exception,
                                          translationExceptionType
                                        )
                                      "
                                    >
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>{{
                                    $t(
                                      "organization.deleteTranslationExceptionType"
                                    )
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </div>
                          </v-col>
                        </div>
                        <v-divider inset></v-divider>
                      </v-col>
                    </v-row>

                    <h3 class="mb-2">
                      {{ $t("organization.deletedExceptions") }}
                    </h3>
                    <v-subheader class="mb-3" v-if="!deletedExceptions.length">
                      {{ $t("organization.deletedExceptionsListEmpty") }}
                    </v-subheader>

                    <v-row v-if="deletedExceptions.length" class="mb-1">
                      <v-col
                        class="pb-0"
                        cols="12"
                        v-for="exception in deletedExceptions"
                        :key="exception.id"
                      >
                        <div class="d-flex">
                          <v-text-field
                            v-model="exception.name"
                            :label="$t('organization.name')"
                            readonly
                            :error="exception.isErrorExceptionType"
                            :error-messages="
                              exception.errorExceptionTypeMessage
                            "
                            outlined
                          ></v-text-field>
                          <div class="mt-2 ml-3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  fab
                                  depressed
                                  small
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="activateException(exception)"
                                >
                                  <v-icon>mdi-arrow-up-thick</v-icon>
                                </v-btn>
                              </template>
                              <span>{{
                                $t("organization.setExceptionActive")
                              }}</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </v-col>
                    </v-row>

                    <div class="mb-10">
                      <v-divider></v-divider>
                    </div>

                    <div class="pb-0 d-flex justify-space-between align-center">
                      <h2
                        class="primary--text font-weight-regular"
                        style="font-size: 20px"
                      >
                        {{ $t("organization.addException") }}
                      </h2>
                      <v-checkbox
                        v-if="isShowCheckboxTranslationExceptionTypes"
                        v-model="isShowTranslationExceptionTypes"
                        :label="$t('organization.addTranslations')"
                        color="primary"
                        hide-details
                        class="mt-0"
                      >
                      </v-checkbox>
                    </div>
                    <v-row class="mb-3">
                      <v-col class="pb-0" cols="12">
                        <v-text-field
                          v-model="newExceptionType"
                          :label="$t('organization.name')"
                          outlined
                          :error="isErrorNewExceptionType"
                          :error-messages="errorNewExceptionTypeMessage"
                        >
                          <template v-slot:append>
                            <img src="../assets/EN.png" alt="EN" />
                          </template>
                        </v-text-field>
                        <div
                          v-if="isShowTranslationExceptionTypes"
                          class="pl-10"
                        >
                          <div
                            v-for="(item, index) in translationExceptionTypes"
                            :key="item.languageCode"
                          >
                            <v-text-field
                              v-model="translationExceptionTypes[index].name"
                              :label="$t('organization.nameTranslation')"
                              outlined
                            >
                              <template v-slot:append>
                                <img
                                  :src="
                                    require('../assets/' +
                                      translationExceptionTypes[index]
                                        .languageCode +
                                      '.png')
                                  "
                                  :alt="item.languageCode"
                                />
                              </template>
                            </v-text-field>
                          </div>
                        </div>
                        <div class="d-flex justify-end">
                          <v-btn
                            color="info"
                            :disabled="isDisabledAddException"
                            @click="createException"
                            >{{ $t("organization.add") }}</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-if="payloadOrganization.issuingOrganization">
                  <v-container>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-subheader
                          class="cmr-details__title justify-space-between"
                        >
                          {{ $t("organization.predefinedGoods") }}
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="btn-two--add"
                                text
                                v-on="on"
                                @click.stop="
                                  () =>
                                    openDialogPredefinedGood('predefinedGoods')
                                "
                              >
                                <v-icon medium>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t("organization.addPredefinedGood")
                            }}</span>
                          </v-tooltip>
                        </v-subheader>
                      </v-col>

                      <v-col cols="12">
                        <v-data-table
                          :headers="predefinedGoodsHeaders.goods"
                          :items="predefinedGoodsList"
                          :options.sync="optionsPredefinedGoodsList"
                          :items-per-page="
                            optionsPredefinedGoodsList.rowsPerPageItems
                          "
                          :server-items-length="totalPredefinedGoodsList"
                          :footer-props="{
                            'items-per-page-options': this.$store.state
                              .rowsPerPageItems,
                            'items-per-page-text': $t('rowsPerPage'),
                          }"
                          :no-data-text="$t('noDataAvailable')"
                        >
                          <template v-slot:item.edit="{ item }">
                            <v-btn fab small color="#fff">
                              <v-icon
                                color="#5b8ff5"
                                @click="
                                  editPredefinedGood(item, 'predefinedGoods')
                                "
                              >
                                mdi-pencil-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:item.delete="{ item }">
                            <v-btn fab small color="#fff">
                              <v-icon
                                color="#5b8ff5"
                                @click="
                                  deletePredefinedGood(
                                    item.id,
                                    'predefinedGoods'
                                  )
                                "
                              >
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>

                      <v-col class="pb-0" cols="12">
                        <v-subheader
                          class="cmr-details__title justify-space-between"
                        >
                          {{ $t("organization.predefinedReturnGoods") }}
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                class="btn-two--add"
                                text
                                v-on="on"
                                @click.stop="
                                  () =>
                                    openDialogPredefinedGood(
                                      'predefinedReturnGoods'
                                    )
                                "
                              >
                                <v-icon medium>mdi-plus</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              $t("organization.addPredefinedReturnGood")
                            }}</span>
                          </v-tooltip>
                        </v-subheader>
                      </v-col>

                      <v-col cols="12">
                        <v-data-table
                          :headers="predefinedGoodsHeaders.returnGoods"
                          :items="predefinedReturnGoodsList"
                          :options.sync="optionsPredefinedReturnGoodsList"
                          :items-per-page="
                            optionsPredefinedReturnGoodsList.rowsPerPageItems
                          "
                          :server-items-length="totalPredefinedReturnGoodsList"
                          :footer-props="{
                            'items-per-page-options': this.$store.state
                              .rowsPerPageItems,
                            'items-per-page-text': $t('rowsPerPage'),
                          }"
                          :no-data-text="$t('noDataAvailable')"
                        >
                          <template v-slot:item.edit="{ item }">
                            <v-btn fab small color="#fff">
                              <v-icon
                                color="#5b8ff5"
                                @click="
                                  editPredefinedGood(
                                    item,
                                    'predefinedReturnGoods'
                                  )
                                "
                              >
                                mdi-pencil-outline
                              </v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:item.delete="{ item }">
                            <v-btn fab small color="#fff">
                              <v-icon
                                color="#5b8ff5"
                                @click="
                                  deletePredefinedGood(
                                    item.id,
                                    'predefinedReturnGoods'
                                  )
                                "
                              >
                                mdi-delete
                              </v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>

                      <v-col>
                        <v-subheader
                          class="cmr-details__title justify-space-between"
                        >
                          {{ $t("organization.carrierOrganisationsList") }}
                        </v-subheader>
                        <v-data-table
                          :headers="carrierOrganizationsHeaders"
                          :items="carrierOrganizationsList"
                          :options.sync="optionsCarrierOrganizationsList"
                          :items-per-page="
                            optionsCarrierOrganizationsList.rowsPerPageItems
                          "
                          :server-items-length="totalCarrierOrganizationsList"
                          :footer-props="{
                            'items-per-page-options': this.$store.state
                              .rowsPerPageItems,
                            'items-per-page-text': $t('rowsPerPage'),
                          }"
                          :no-data-text="$t('noDataAvailable')"
                        >
                          <template v-slot:item.organizationType="{ item }">
                            <span v-if="item.organizationType === 1">{{
                              $t("organization.customer")
                            }}</span>
                            <span v-if="item.organizationType === 2">{{
                              $t("organization.transport_company")
                            }}</span>
                            <span v-if="item.organizationType === 3">{{
                              $t("organization.management_company")
                            }}</span>
                            <span v-if="item.organizationType === 4">{{
                              $t("organization.government_authority")
                            }}</span>
                            <span v-if="item.organizationType === 5">{{
                              $t("organization.sender_receiver_transport")
                            }}</span>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-if="!isGovernment">
                  <v-container>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-btn class="float-right" @click="dialogHelp = true">{{
                          $t("help")
                        }}</v-btn>
                        <v-subheader>
                          {{ $t("organization.onDriverSignatureToSender") }}
                        </v-subheader>
                        <v-text-field
                          v-model="
                            payloadOrganization.subjectOnDriverSignatureToSender
                          "
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="
                            payloadOrganization.bodyOnDriverSignatureToSender
                          "
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <v-subheader>
                          {{ $t("organization.onDriverSignatureToCarrier") }}
                        </v-subheader>
                        <v-text-field
                          v-model="
                            payloadOrganization.subjectOnDriverSignatureToCarrier
                          "
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="
                            payloadOrganization.bodyOnDriverSignatureToCarrier
                          "
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <v-subheader>
                          {{ $t("organization.onReceiverSignatureToSender") }}
                        </v-subheader>
                        <v-text-field
                          v-model="
                            payloadOrganization.subjectOnReceiverSignatureToSender
                          "
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="
                            payloadOrganization.bodyOnReceiverSignatureToSender
                          "
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <v-subheader>
                          {{ $t("organization.onReceiverSignatureToCarrier") }}
                        </v-subheader>
                        <v-text-field
                          v-model="
                            payloadOrganization.subjectOnReceiverSignatureToCarrier
                          "
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="
                            payloadOrganization.bodyOnReceiverSignatureToCarrier
                          "
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <v-subheader>
                          {{ $t("organization.onReceiverSignatureToReceiver") }}
                        </v-subheader>
                        <v-text-field
                          v-model="
                            payloadOrganization.subjectOnReceiverSignatureToReceiver
                          "
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="
                            payloadOrganization.bodyOnReceiverSignatureToReceiver
                          "
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row v-if="payloadOrganization.palletAdditionLogEmail">
                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <v-subheader>
                          {{ $t("organization.returnGoodsEmails") }}
                        </v-subheader>
                        <v-text-field
                          v-model="payloadOrganization.subjectReturnGoodsEmails"
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="payloadOrganization.bodyReturnGoodsEmails"
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-row v-if="payloadOrganization.exceptionRegistrationSign">
                      <v-col>
                        <v-divider></v-divider>
                        <h2
                          class="mb-3 mt-4 font-weight-medium"
                          style="font-size: 18px"
                        >
                          {{ $t("organization.exceptions") }}
                        </h2>
                        <h5 class="font-weight-regular" style="font-size: 16px">
                          {{ $t("organization.emailsList") }}
                        </h5>
                        <v-subheader v-if="!exceptionEmails.length">
                          {{ $t("organization.emailsListEmpty") }}
                        </v-subheader>
                      </v-col>

                      <template class="mb-3" v-if="exceptionEmails.length">
                        <v-col
                          class="pb-0"
                          cols="12"
                          v-for="email in exceptionEmails"
                          :key="email.name"
                        >
                          <div class="d-flex">
                            <v-text-field
                              v-model="email.name"
                              readonly
                              :label="$t('user.email')"
                              outlined
                              hide-details
                            ></v-text-field>
                            <div class="mt-2 ml-3">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    fab
                                    depressed
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    :disabled="
                                      !$isPermitted(
                                        'modifyOrDeleteOrganizations'
                                      )
                                    "
                                    @click="deleteEmail(email.name)"
                                  >
                                    <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                </template>
                                <span>{{
                                  $t("organization.deleteEmail")
                                }}</span>
                              </v-tooltip>
                            </div>
                          </div>
                        </v-col>
                      </template>

                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <h5
                          class="mb-4 mt-5 font-weight-regular"
                          style="font-size: 16px"
                        >
                          {{ $t("organization.addEmail") }}
                        </h5>
                        <v-text-field
                          v-model="newEmail"
                          :label="$t('user.email')"
                          outlined
                          :error="isErrorAddEmail"
                          :error-messages="errorMessageAddEmail"
                        ></v-text-field>
                        <div class="d-flex justify-end">
                          <v-btn color="info" @click="addEmail">
                            {{ $t("organization.add") }}
                          </v-btn>
                        </div>
                      </v-col>

                      <v-col class="pb-0" cols="12">
                        <v-divider></v-divider>
                        <v-subheader>
                          {{ $t("organization.exceptionsEmails") }}
                        </v-subheader>
                        <v-text-field
                          v-model="payloadOrganization.subjectOnException"
                          :label="$t('organization.title')"
                          outlined
                        ></v-text-field>
                        <v-textarea
                          v-model="payloadOrganization.bodyOnException"
                          :label="$t('organization.body')"
                          outlined
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item v-if="editedId !== -1">
                  <v-container>
                    <v-row>
                      <v-col>
                        <v-file-input
                          v-model="documentFileInput"
                          :placeholder="
                            $t('organization.attachedFilesUploadDocuments')
                          "
                          :label="$t('organization.attachedFilesInput')"
                        ></v-file-input>
                        <v-btn
                          @click.stop="sendDocument()"
                          :disabled="
                            !documentFileInput || documentFileIsLoading
                          "
                          class="btn-two mobile-block mr-0 mr-sm-6"
                          color="#08a657"
                          height="56px"
                          text
                        >
                          {{ $t("organization.attachedFilesUploadDocuments") }}
                        </v-btn>
                      </v-col>
                      <v-progress-linear
                        v-if="documentFileIsLoading || documentFileIsUploading"
                        indeterminate
                        color="teal"
                      ></v-progress-linear>
                      <v-alert
                        v-if="documentFileError"
                        dismissible
                        type="error"
                        color="red"
                      >
                        {{ documentFileError }}
                      </v-alert>
                    </v-row>
                  </v-container>
                  <v-container>
                    <v-row
                      v-for="doc in documentFileList"
                      :key="doc.id"
                      align="center"
                    >
                      <v-col cols="2">
                        <v-checkbox
                          v-model="doc.mailingInclusionSign"
                          color="primary"
                          hide-details
                          @change="(e) => handlerDocChange(e, doc)"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="8">{{ doc.name }}</v-col>
                      <v-col cols="2">
                        <v-btn
                          fab
                          small
                          color="#fff"
                          @click="deleteDoc(doc.id)"
                        >
                          <v-icon color="#5b8ff5">mdi-delete</v-icon>
                        </v-btn>
                      </v-col>
                      <v-col cols="12"><v-divider></v-divider></v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn right text color="primary" @click="resetFormOrganization">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              right
              text
              color="primary"
              @click="applyForm"
              :disabled="documentFileIsLoadingLogo"
            >
              {{ $t("apply") }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHelp" max-width="600px">
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{ $t("help") }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-for="help in helps" :key="help.name" class="list">
            <div class="list__name">{{ help.name }}</div>
            <div class="list__d">{{ $t(help.t) }}</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn right text color="primary" @click="dialogHelp = false">
            {{ $t("close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPredefinedGood" max-width="600px">
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{
            payloadPredefinedGood.id
              ? "Edit predefined good"
              : "Add predefined good"
          }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            ref="formPredefinedGood"
            v-model="formPredefinedGoodValid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col class="pb-0" cols="12">
                  <v-textarea
                    v-model="payloadPredefinedGood.goodsNature"
                    :rules="[rules.required]"
                    :label="$t('crm.description')"
                    required
                    outlined
                    counter="250"
                    maxlength="250"
                  ></v-textarea>
                </v-col>
                <v-col class="pb-0" cols="12">
                  <v-textarea
                    v-model="payloadPredefinedGood.marks"
                    :label="$t('crm.marks')"
                    outlined
                    counter="200"
                    maxlength="200"
                  ></v-textarea>
                </v-col>
                <v-col class="pb-0" cols="12">
                  <v-text-field
                    v-model="payloadPredefinedGood.packingMethod"
                    :label="$t('crm.packing_method')"
                    outlined
                    counter="80"
                    maxlength="80"
                  ></v-text-field>
                </v-col>
                <v-col class="pb-0" cols="12">
                  <v-text-field
                    v-model="payloadPredefinedGood.statisticNumber"
                    :label="$t('crm.statistic_number')"
                    outlined
                    counter="50"
                    maxlength="50"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            right
            text
            color="primary"
            @click="closeDialogPredefinedGood('predefinedGoods')"
          >
            {{ $t("close") }}
          </v-btn>
          <v-btn
            right
            text
            color="primary"
            @click="savePredefinedGood('predefinedGoods')"
          >
            {{ $t("apply") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPredefinedReturnGood" max-width="600px">
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{
            payloadPredefinedReturnGood.id
              ? "Edit predefined return good"
              : "Add predefined return good"
          }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form
            ref="formPredefinedReturnGood"
            v-model="formPredefinedReturnGoodValid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col class="pb-0" cols="12">
                  <v-textarea
                    v-model="payloadPredefinedReturnGood.typeCodeDescription"
                    :rules="[rules.required]"
                    :label="$t('crm.description')"
                    required
                    outlined
                    counter="100"
                    maxlength="100"
                  ></v-textarea>
                </v-col>
                <v-col class="pb-0" cols="12">
                  <v-text-field
                    v-model="payloadPredefinedReturnGood.unitWeight"
                    :rules="[rules.decimal]"
                    :label="$t('crm.unitWeight')"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            right
            text
            color="primary"
            @click="closeDialogPredefinedGood('predefinedReturnGoods')"
          >
            {{ $t("close") }}
          </v-btn>
          <v-btn
            right
            text
            color="primary"
            @click="savePredefinedGood('predefinedReturnGoods')"
          >
            {{ $t("apply") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar.isShow" :timeout="8000">
      {{ snackbar.text }}
      <v-btn color="white" text @click="snackbar.isShow = false">
        {{ $t("close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import { i18n } from '@/plugins/i18n'
import { mapActions } from "vuex";
import config from "../config";
import Axios from "axios";
import { initialTranslationExceptionTypes } from "../constants/initialTranslationExceptionTypes";

const qs = require("querystring");

export default {
  data() {
    return {
      user: {},
      options: {},
      payload: {
        Id: 0,
        name: "",
        street: "",
        postalCode: "",
        place: "",
        countryCode: "",
        organizationType: 0,
        Search: "",
        Page: 1,
        Limit: 10,
        OrderBy: "",
        Direction: "asc",
        organizationId: null,
      },
      dialogOrganization: false,
      showSearch: false,
      searchText: "",
      deleteDialog: false,
      payloadOrganization: {
        name: "",
        street: "",
        postalCode: "",
        place: "",
        countryCode: "",
        carrierCode: "",
        organizationType: "",
        organizationTypePrev: "",
        organizationId: null,
        vat: "",
        duns: "",
        ean: "",
        bodyOnDriverSignatureToCarrier: "",
        bodyOnDriverSignatureToSender: "",
        bodyOnReceiverSignatureToCarrier: "",
        bodyOnReceiverSignatureToReceiver: "",
        bodyOnReceiverSignatureToSender: "",
        subjectOnDriverSignatureToCarrier: "",
        subjectOnDriverSignatureToSender: "",
        subjectOnReceiverSignatureToCarrier: "",
        subjectOnReceiverSignatureToReceiver: "",
        subjectOnReceiverSignatureToSender: "",
        setLoadUnloadTimeSign: false,
        barcodePalletAdditionModeSign: false,
        palletAdditionLogEmail: "",
        subjectReturnGoodsEmails: "",
        bodyReturnGoodsEmails: "",
        canSignedBySubordinateSign: false,

        canSetPaymentSign: false,
        dashboardPaymentSign: false,
        dashboardDisplaySign: false,

        exceptionRegistrationSign: false,
        exceptionNotifyEmails: "",

        webhookUrl: "",
        webhookAuthorization: "",

        webhookReadyToSigningSign: false,
        webhookClosedSign: false,
        webhookDriverSigningSign: false,
        webhookSenderSigningSign: false,
        bodyOnException: "",
        subjectOnException: "",
        issuingOrganization: false,
        pdfLogRegistration: false,
        cmrModifyWebhookUrl: "",
        apiChangesNotificationEmail: "",
        manualPickingGoodlinesSign: false,
        noTranslationOnCmrSign: false,
      },
      defaultPyloadOrganization: {
        name: "",
        street: "",
        postalCode: "",
        place: "",
        countryCode: "",
        carrierCode: "",
        organizationType: "",
        organizationTypePrev: "",
        vat: "",
        duns: "",
        ean: "",
        bodyOnDriverSignatureToCarrier: "",
        bodyOnDriverSignatureToSender: "",
        bodyOnReceiverSignatureToCarrier: "",
        bodyOnReceiverSignatureToReceiver: "",
        bodyOnReceiverSignatureToSender: "",
        subjectOnDriverSignatureToCarrier: "",
        subjectOnDriverSignatureToSender: "",
        subjectOnReceiverSignatureToCarrier: "",
        subjectOnReceiverSignatureToReceiver: "",
        subjectOnReceiverSignatureToSender: "",
        setLoadUnloadTimeSign: false,
        barcodePalletAdditionModeSign: false,
        palletAdditionLogEmail: "",
        subjectReturnGoodsEmails: "",
        bodyReturnGoodsEmails: "",
        canSignedBySubordinateSign: false,

        canSetPaymentSign: false,
        dashboardPaymentSign: false,
        dashboardDisplaySign: false,
        exceptionRegistrationSign: false,
        exceptionNotifyEmails: "",
        canChangeSign: true,

        webhookUrl: "",
        webhookAuthorization: "",

        webhookReadyToSigningSign: false,
        webhookClosedSign: false,
        webhookDriverSigningSign: false,
        webhookSenderSigningSign: false,
        bodyOnException: "",
        subjectOnException: "",
        issuingOrganization: false,
        pdfLogRegistration: false,
        cmrModifyWebhookUrl: "",
        apiChangesNotificationEmail: "",
        manualPickingGoodlinesSign: false,
        noTranslationOnCmrSign: false,
      },
      emptyEmailSettings: {
        bodyOnDriverSignatureToCarrier: "",
        bodyOnDriverSignatureToSender: "",
        bodyOnReceiverSignatureToCarrier: "",
        bodyOnReceiverSignatureToReceiver: "",
        bodyOnReceiverSignatureToSender: "",
        subjectOnDriverSignatureToCarrier: "",
        subjectOnDriverSignatureToSender: "",
        subjectOnReceiverSignatureToCarrier: "",
        subjectOnReceiverSignatureToReceiver: "",
        subjectOnReceiverSignatureToSender: "",
        subjectReturnGoodsEmails: "",
        bodyReturnGoodsEmails: "",
      },
      countryCodes: [],
      formOrganizationValid: false,
      editedId: -1,
      allOrganizations: [],
      parentId: "",
      parentOrgSearch: "",
      parentOrgLoading: false,
      parentOrgLastQuery: "",
      parentOrgDebounceTimer: null,
      parentOrgAbort: null,
      parentOrgReqId: 0,
      snackbar: {
        isShow: false,
        text: "",
      },

      tab: 0,
      isGovernment: false,
      dialogHelp: false,
      helps: [
        { name: "<code>", t: "" },
        { name: "<CMRCode>", t: "" },
        { name: "<LoadOrderID>", t: "" },
        { name: "<UnLoadOrderID>", t: "" },
        { name: "<Status>", t: "" },
        { name: "<DeliveryStreet>", t: "" },
        { name: "<DeliveryPostalCode>", t: "" },
        { name: "<DeliveryPlace>", t: "" },
        { name: "<DeliveryCountryCode>", t: "" },
        { name: "<CollectionStreet>", t: "" },
        { name: "<CollectionPostalCode>", t: "" },
        { name: "<CollectionPlace>", t: "" },
        { name: "<CollectionCountryCode>", t: "" },
        { name: "<SenderInstructions>", t: "" },
        { name: "<Franco>", t: "" },
        { name: "<CarrierReservations>", t: "" },
        { name: "<SpecialAgreements>", t: "" },
        { name: "<DrawnUpPlace>", t: "" },
        { name: "<DrawnUpDate>", t: "" },
        { name: "<AttachedDocuments>", t: "" },
        { name: "<TransportType>", t: "" },
        { name: "<CollectionDate>", t: "" },
        { name: "<DeliveryDate>", t: "" },
        { name: "<ReceptionExpectedTime>", t: "" },
        { name: "<EstimatedDeliveryTime>", t: "" },
        { name: "<SenderEmail>", t: "" },
        { name: "<CarrierEmail>", t: "" },
        { name: "<ReceiverEmail>", t: "" },
        { name: "<DriverEmail>", t: "" },
        { name: "<LoadWeight>", t: "" },
        { name: "<PalletNumber>", t: "" },
        { name: "<Type>", t: "" },
        { name: "<EscalateCommentSenderEmail>", t: "" },
        { name: "<EscalateCommentCarrierEmail>", t: "" },
        { name: "<EscalateCommentRecipientEmail>", t: "" },
        { name: "<TripID>", t: "" },
        { name: "<SenderSupportEmail>", t: "" },
        { name: "<CarrierSupportEmail>", t: "" },
        { name: "<RecipientSupportEmail>", t: "" },
        { name: "<SenderOrganizationName>", t: "" },
        { name: "<SenderOrganizationType>", t: "" },
        { name: "<SenderCountryCode>", t: "" },
        { name: "<SenderPostalCode>", t: "" },
        { name: "<SenderPlace>", t: "" },
        { name: "<SenderStreet>", t: "" },
        { name: "<RecipientOrganizationName>", t: "" },
        { name: "<RecipientOrganizationType>", t: "" },
        { name: "<RecipientCountryCode>", t: "" },
        { name: "<RecipientPostalCode>", t: "" },
        { name: "<RecipientPlace>", t: "" },
        { name: "<RecipientStreet>", t: "" },
        { name: "<CarrierOrganizationName>", t: "" },
        { name: "<CarrierOrganizationType>", t: "" },
        { name: "<CarrierCountryCode>", t: "" },
        { name: "<CarrierPostalCode>", t: "" },
        { name: "<CarrierPlace>", t: "" },
        { name: "<CarrierStreet>", t: "" },
        { name: "<CarrierCode>", t: "" },
        { name: "<ExtraEmailInfo>", t: "" },
        { name: "<ExceptionName> (only for exceptions)", t: "" },
        { name: "<ExceptionPackagesNumber> (only for exceptions)", t: "" },
        { name: "<ExceptionRemarks> (only for exceptions)", t: "" },
        { name: "<ExceptionBarcodes> (only for exceptions)", t: "" },
        { name: "<ExceptionGoodsLine> (only for exceptions)", t: "" },
      ],
      documentFileInput: null,
      documentFileIsLoading: false,
      documentFile: "",
      documentFileName: "",
      documentFileError: null,
      documentFileList: [],
      documentFileIsUploading: false,
      documentFileInputLogo: null,
      documentFileIsLoadingLogo: false,
      documentFileLogo: "",
      documentFileNameLogo: "",
      documentFileErrorLogo: null,
      documentFileListLogo: [],
      documentFileIsUploadingLogo: false,
      exceptionsList: [],
      newExceptionType: "",
      isErrorNewExceptionType: false,
      errorNewExceptionTypeMessage: "",
      isDisabledAddException: false,
      newEmail: "",
      isErrorAddEmail: false,
      errorMessageAddEmail: "",
      exceptionEmails: [],
      isShowCheckboxTranslationExceptionTypes: false,
      isShowTranslationExceptionTypes: false,
      translationExceptionTypes: initialTranslationExceptionTypes(),

      dialogPredefinedGood: false,
      dialogPredefinedReturnGood: false,

      rules: {
        required: (value) => !!value || this.$i18n.t("field_is_required"),
        number: (value) => {
          const pattern = /^\d+$/;
          return (
            value === null ||
            value === "" ||
            pattern.test(value) ||
            this.$i18n.t("field_is_not_number")
          );
        },
        decimal: (value) => {
          const pattern = /^[0-9]*[.,]?[0-9]+$/;
          return (
            value === null ||
            value === "" ||
            pattern.test(value) ||
            this.$i18n.t("field_is_not_number")
          );
        },
        length: (len) => (v) =>
          v.length <= len || this.$i18n.t("fieldWrongLength"),
      },

      optionsPredefinedGoodsList: {
        rowsPerPageItems: 5,
        page: 1,
        itemsPerPage: 5,
      },
      optionsPredefinedReturnGoodsList: {
        rowsPerPageItems: 5,
        page: 1,
        itemsPerPage: 5,
      },
      optionsCarrierOrganizationsList: {
        rowsPerPageItems: 10,
        page: 1,
        itemsPerPage: 10,
      },

      totalPredefinedGoodsList: 0,
      totalPredefinedReturnGoodsList: 0,
      totalCarrierOrganizationsList: 0,

      formPredefinedGoodValid: false,
      formPredefinedReturnGoodValid: false,

      payloadPredefinedGood: {
        id: null,
        organizationsId: null,
        goodsNature: "",
        marks: "",
        packingMethod: "",
        statisticNumber: "",
      },
      defaultPredefinedGood: {
        id: null,
        organizationsId: null,
        goodsNature: "",
        marks: "",
        packingMethod: "",
        statisticNumber: "",
      },

      payloadPredefinedReturnGood: {
        id: null,
        organizationsId: null,
        typeCodeDescription: "",
        unitWeight: "",
      },
      defaultPredefinedReturnGood: {
        id: null,
        organizationsId: null,
        typeCodeDescription: "",
        unitWeight: "",
      },

      predefinedGoodsList: [],
      predefinedReturnGoodsList: [],

      carrierOrganizationsList: [],
    };
  },
  created() {
    this.GET_COUNTRIES();
    this.getCurrentUser();
  },
  computed: {
    parentOrgItems() {
      const selfId = this.payloadOrganization.id;
      if (!selfId) return this.allOrganizations;
      return this.allOrganizations.filter((el) => el.id !== selfId);
    },
    activeExceptions() {
      return this.exceptionsList.filter((exception) => exception.status === 1);
    },
    deletedExceptions() {
      return this.exceptionsList.filter((exception) => exception.status === 2);
    },
    headers() {
      return [
        {
          text: "",
          value: "edit",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: "",
          value: "delete",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.name"),
          value: "name",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.mainOrganization"),
          value: "mainOrganization",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.carrier_code"),
          value: "carrierCode",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.country_code"),
          value: "countryCode",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.postal_code"),
          value: "postalCode",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.place"),
          value: "place",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.street"),
          value: "street",
          width: "1%",
          align: "left",
        },
        {
          text: this.$i18n.t("organization.organization_type"),
          value: "organizationType",
          width: "1%",
          align: "left",
          sortable: false,
        },
      ];
    },
    totalItems() {
      return this.$store.getters.ORGANIZATIONS_TOTAL;
    },
    organizationsData() {
      return this.$store.getters.ORGANIZATIONS_LIST;
    },
    formTitle() {
      return this.editedId === -1
        ? this.$i18n.t("organization.new_organization")
        : this.$i18n.t("organization.edit_organization");
    },
    organizationTypeDefault() {
      return [
        { value: 1, name: this.$i18n.t("organization.customer") },
        { value: 2, name: this.$i18n.t("organization.transport_company") },
        { value: 3, name: this.$i18n.t("organization.management_company") },
        { value: 4, name: this.$i18n.t("organization.government_authority") },
        {
          value: 5,
          name: this.$i18n.t("organization.sender_receiver_transport"),
        },
      ];
    },
    organizationType() {
      let organisationList;
      let parentTypeMain = this.allOrganizations.some(
        (el) => el.organizationType === 3 && el.id === this.parentId
      );
      if (parentTypeMain) {
        organisationList = [...this.organizationTypeDefault];
      } else {
        organisationList = this.organizationTypeDefault.filter(
          (el) => el.value !== 4
        );
      }

      if (this.payloadOrganization.organizationTypePrev !== 3) {
        organisationList = organisationList.filter((el) => el.value !== 3);
      }

      return organisationList;
    },
    setDisabled() {
      if (this.allOrganizations.length > 0) {
        const parentOrganisation = this.allOrganizations.find(
          (el) => el.id === this.payloadOrganization.organizationId
        );

        if (
          this.user.canSetPaymentSign &&
          (this.payloadOrganization.organizationType === 3 ||
            (parentOrganisation && parentOrganisation.canSetPaymentSign))
        ) {
          return false;
        }
      }
      return true;
    },

    canManualCreationUseSign() {
      if (!this.payloadOrganization?.organizationId) return false;

      const parentOrganisation = this.allOrganizations.find(
        (el) => el.id === this.payloadOrganization.organizationId
      );

      return !!parentOrganisation?.canManualCreationUseSign;
    },

    predefinedGoodsHeaders() {
      return {
        goods: [
          {
            text: this.$i18n.t("crm.goods_nature"),
            value: "goodsNature",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("crm.marks"),
            value: "marks",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("crm.packing_method"),
            value: "packingMethod",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("crm.statistic_number"),
            value: "statisticNumber",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: "",
            value: "edit",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: "",
            value: "delete",
            width: "1%",
            align: "left",
            sortable: false,
          },
        ],
        returnGoods: [
          {
            text: this.$i18n.t("crm.description"),
            value: "typeCodeDescription",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("crm.unitWeight"),
            value: "unitWeight",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: "",
            value: "edit",
            width: "1%",
            align: "left",
            sortable: false,
          },
          {
            text: "",
            value: "delete",
            width: "1%",
            align: "left",
            sortable: false,
          },
        ],
      };
    },
    carrierOrganizationsHeaders() {
      return [
        {
          text: this.$i18n.t("organization.name"),
          value: "name",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.carrier_code"),
          value: "carrierCode",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.country_code"),
          value: "countryCode",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.postal_code"),
          value: "postalCode",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.place"),
          value: "place",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.street"),
          value: "street",
          width: "1%",
          align: "left",
          sortable: false,
        },
        {
          text: this.$i18n.t("organization.organization_type"),
          value: "organizationType",
          width: "1%",
          align: "left",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "SET_ORGANIZATIONS",
      "DELETE_ORGANIZATION",
      "UPDATE_ORGANIZATIONS",
      "GET_COUNTRIES",
      "GET_ORGANIZATION",
    ]),

    getCarrierOrganizationsList() {
      Axios({
        url:
          config.apiBaseUrl +
          `api/organization/carrier-list?organizationId=${
            this.payloadOrganization.id
          }`,
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(({ data }) => {
          this.carrierOrganizationsList = data;
          this.totalCarrierOrganizationsList = data.total;
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    getPredefinedGoodsList(tableOptions) {
      const payload = {
        organizationsId: this.payloadOrganization.id,
        ...tableOptions,
      };

      Axios.post(
        config.apiBaseUrl + `api/predefinedGoods/list`,
        qs.stringify(payload),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then(({ data }) => {
          this.predefinedGoodsList = data.data;
          this.totalPredefinedGoodsList = data.total;
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    getPredefinedReturnGoodsList(tableOptions) {
      const payload = {
        organizationsId: this.payloadOrganization.id,
        ...tableOptions,
      };

      Axios.post(
        config.apiBaseUrl + `api/predefinedReturnGoods/list`,
        qs.stringify(payload),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then(({ data, status }) => {
          this.predefinedReturnGoodsList = data.data;
          this.totalPredefinedReturnGoodsList = data.total;
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    openDialogPredefinedGood(type) {
      if (type === "predefinedGoods") {
        this.payloadPredefinedGood = { ...this.defaultPredefinedGood };
        this.dialogPredefinedGood = true;
      }
      if (type === "predefinedReturnGoods") {
        this.payloadPredefinedReturnGood = {
          ...this.defaultPredefinedReturnGood,
        };
        this.dialogPredefinedReturnGood = true;
      }
    },
    closeDialogPredefinedGood(type) {
      if (type === "predefinedGoods") {
        this.$refs.formPredefinedGood.reset();
        this.payloadPredefinedGood = { ...this.defaultPredefinedGood };
        this.dialogPredefinedGood = false;
      }
      if (type === "predefinedReturnGoods") {
        this.$refs.formPredefinedReturnGood.reset();
        this.payloadPredefinedReturnGood = {
          ...this.defaultPredefinedReturnGood,
        };
        this.dialogPredefinedReturnGood = false;
      }
    },

    editPredefinedGood(item, type) {
      if (type === "predefinedGoods") {
        this.payloadPredefinedGood = { ...item };
        this.dialogPredefinedGood = true;
      }
      if (type === "predefinedReturnGoods") {
        this.payloadPredefinedReturnGood = { ...item };
        this.dialogPredefinedReturnGood = true;
      }
    },
    async savePredefinedGood(type) {
      let payload = {};
      let url = config.apiBaseUrl;

      let formRef;
      let resetFormRef;
      let getListFunction;

      if (type === "predefinedGoods") {
        formRef = this.$refs.formPredefinedGood;
        resetFormRef = () => this.$refs.formPredefinedGood.reset();
        getListFunction = () =>
          this.getPredefinedGoodsList(this.getTableOptions(type));

        payload = { ...this.payloadPredefinedGood };
      } else if (type === "predefinedReturnGoods") {
        formRef = this.$refs.formPredefinedReturnGood;

        resetFormRef = () => this.$refs.formPredefinedReturnGood.reset();
        getListFunction = () =>
          this.getPredefinedReturnGoodsList(this.getTableOptions(type));
        payload = { ...this.payloadPredefinedReturnGood };
      } else {
        return;
      }

      if (!formRef.validate()) {
        return;
      }
      payload.organizationsId = this.payloadOrganization.id;
      url += payload.id ? `api/${type}/edit` : `api/${type}/create`;

      try {
        const response = await Axios.post(url, qs.stringify(payload), {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        if (response.status === 200) {
          resetFormRef();
          this.closeDialogPredefinedGood(type);
          getListFunction();
        }
      } catch (error) {
        console.error(error);
      }
    },

    deletePredefinedGood(id, type) {
      let confirmText = "are you shure you want to delete this item?";

      if (confirm(confirmText)) {
        Axios.get(config.apiBaseUrl + `api/${type}/delete?id=${id}`, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then((response) => {
            if (response.status === 200) {
              if (type === "predefinedGoods")
                this.getPredefinedGoodsList(this.getTableOptions(type));
              if (type === "predefinedReturnGoods")
                this.getPredefinedReturnGoodsList(this.getTableOptions(type));
            }
          })
          .catch(function(error) {
          if (error.sessionExpiryHandled) return;
            /* eslint-disable */
            console.error(error.response.data);
            alert(error.response.data);
          });
      }
    },

    isValidUrl(str) {
      const url = (str || "").trim();
      if (url === "") return true;
      const pattern = new RegExp(
        "^([a-zA-Z]+:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$", // fragment locator
        "i"
      );
      return pattern.test(url);
    },
    deleteEmail(email) {
      let filteredEmails = this.exceptionEmails.filter(
        (item) => item.name !== email
      );

      if (!filteredEmails.length) {
        this.payloadOrganization.exceptionNotifyEmails = "";
        return;
      }

      this.payloadOrganization.exceptionNotifyEmails = filteredEmails
        .map((a) => `${Object.values(a)}`)
        .join(",");
    },
    handleAddTranslations(exception) {
      let addedTranslationExceptionTypes = [];
      if (exception.translationExceptionTypes) {
        addedTranslationExceptionTypes = initialTranslationExceptionTypes().reduce(
          (acc, itm) => {
            const find = exception.translationExceptionTypes.find(
              (item) => item.languageCode === itm.languageCode
            );
            if (find) {
              acc.push(find);
              return acc;
            }
            acc.push(itm);
            return acc;
          },
          []
        );
        exception.translationExceptionTypes = addedTranslationExceptionTypes;
      } else {
        exception.translationExceptionTypes = initialTranslationExceptionTypes();
      }
    },
    handleEditException(exception, index) {
      if (!exception.name.trim()) {
        this.$refs.exceptionInput[index].focus();
        exception.isErrorExceptionType = true;
        exception.errorExceptionTypeMessage = this.$i18n.t(
          "organization.exceptionTypeError"
        );
        const newList = [...this.exceptionsList];
        const exceptionIdx = newList.findIndex(
          (excep) => excep.id === exception.id
        );
        newList.splice(exceptionIdx, 1, exception);
        this.exceptionsList = newList;
        return;
      }
      this.checkException(
        exception,
        () => this.editException(exception),
        "Are you sure you want to edit the Exception type?"
      );
    },
    handleDeleteException(exception, translationExceptionType) {
      if (translationExceptionType) {
        this.checkException(
          exception,
          () => this.editException(exception, translationExceptionType),
          "Are you sure you want to delete the translation of Exception type?"
        );
      } else {
        this.checkException(
          exception,
          () => this.deleteException(exception.id),
          "Are you sure you want to delete the Exception type?"
        );
      }
    },
    getExeptionsList() {
      const payload = {
        organizationsId: this.payloadOrganization.id,
        status: 0,
      };

      Axios.post(
        config.apiBaseUrl + "api/ExceptionType/list",
        qs.stringify(payload),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            const sortedData = response.data.data.map((item) => {
              if (item.translationExceptionTypes) {
                item.translationExceptionTypes.sort((a, b) =>
                  a.languageCode.localeCompare(b.languageCode)
                );
              }
              return item;
            });

            this.exceptionsList = sortedData;
            this.exceptionsList.forEach((exception) => {
              exception.isErrorExceptionType = false;
              exception.errorExceptionTypeMessage = "";
              if (exception.translationExceptionTypes) {
                exception.translationExceptionTypes.forEach((item) => {
                  item.isAdded = true;
                });
              }
            });
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    checkException(exception, action, text) {
      Axios({
        url: config.apiBaseUrl + `api/ExceptionType/check?id=${exception.id}`,
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            if (!response.data.check) {
              const confirmEdit = confirm(`${response.data.info}. ${text}`);
              if (!confirmEdit) {
                // this.getExeptionsList()
                return;
              }
            }
            action();
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    createException() {
      if (!this.newExceptionType.trim()) {
        this.isErrorNewExceptionType = true;
        this.errorNewExceptionTypeMessage = this.$i18n.t(
          "organization.exceptionTypeError"
        );
        return;
      }

      this.isDisabledAddException = true;

      const payload = {
        organizationsId: this.payloadOrganization.id,
        name: this.newExceptionType.trim(),
        status: 1,
        translationExceptionTypes: [],
      };

      if (this.isShowTranslationExceptionTypes) {
        payload.translationExceptionTypes = this.translationExceptionTypes.filter(
          (item) => item.name.trim()
        );
      }

      Axios({
        url: config.apiBaseUrl + `api/ExceptionType/create`,
        method: "POST",
        data: payload,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.getExeptionsList();
            this.newExceptionType = "";
            this.translationExceptionTypes.forEach((item) => {
              item.name = "";
            });
            this.isShowCheckboxTranslationExceptionTypes = false;
            this.isShowTranslationExceptionTypes = false;
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
          this.translationExceptionTypes.forEach((item) => {
            item.name = "";
          });
          this.isShowCheckboxTranslationExceptionTypes = false;
          this.isShowTranslationExceptionTypes = false;
        })
        .finally(() => (this.isDisabledAddException = false));

      this.isErrorNewExceptionType = false;
      this.errorNewExceptionTypeMessage = "";
    },
    editException(exception, translationExceptionType) {
      if (exception.status === 2) exception.status = 1;
      const payload = {
        id: exception.id,
        organizationsId: this.payloadOrganization.id,
        name: exception.name,
        translationExceptionTypes: [],
      };

      if (translationExceptionType) {
        const filteredTranslationExceptionTypes = exception.translationExceptionTypes.filter(
          (item) => item.name !== translationExceptionType.name
        );
        exception.translationExceptionTypes = filteredTranslationExceptionTypes;
      }

      if (exception.translationExceptionTypes) {
        const filteredTranslationExceptionTypes = exception.translationExceptionTypes.filter(
          (item) => item.name.trim()
        );
        filteredTranslationExceptionTypes.map((item) => (item.isAdded = true));
        exception.translationExceptionTypes = filteredTranslationExceptionTypes;
        payload.translationExceptionTypes = filteredTranslationExceptionTypes;
      }

      Axios({
        url: config.apiBaseUrl + `api/ExceptionType/edit`,
        method: "POST",
        data: payload,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            // this.getExeptionsList()
            this.exceptionsList.forEach((exception) => {
              exception.isErrorExceptionType = false;
              exception.errorExceptionTypeMessage = "";
            });
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        })
        .finally(() => (this.isDisabledAddException = false));
    },
    deleteException(id) {
      Axios.get(config.apiBaseUrl + `api/ExceptionType/delete?id=${id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.getExeptionsList();
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    activateException(exception) {
      this.editException(exception);
    },

    addEmail() {
      const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      if (!this.newEmail.trim()) {
        this.isErrorAddEmail = true;
        this.errorMessageAddEmail = this.$i18n.t(
          "organization.emptyEmailError"
        );
        return;
      }
      if (!regex.test(this.newEmail)) {
        this.isErrorAddEmail = true;
        this.errorMessageAddEmail = this.$i18n.t(
          "organization.incorrectEmailError"
        );
        return;
      }

      this.payloadOrganization.exceptionNotifyEmails += `${
        this.payloadOrganization.exceptionNotifyEmails ? "," : ""
      }${this.newEmail}`;
      this.newEmail = "";

      this.isErrorAddEmail = false;
      this.errorMessageAddEmail = "";
    },

    isSelected() {
      if (this.payloadOrganization.dashboardPaymentSign === false) {
        this.payloadOrganization.dashboardDisplaySign = false;
      }
    },
    getCurrentUser() {
      const $this = this;

      Axios.get(config.apiBaseUrl + "user", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
        .then(function(response) {
          if (response.status === 200) {
            $this.user = { ...response.data };
          }
        })
        .catch(function(error) {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    countryList() {
      let me = this;
      this.$store.getters.COUNTRIES_LIST.forEach(function(item) {
        me.countryCodes.push({
          value: item.code,
          codeName: item.name,
        });
      });
    },

    newOrganization() {
      this.countryList();

      this.parentOrgSearch = "";
      this.parentOrgLastQuery = "";
      this.allOrganizations = [];

      this.fetchParentOrganizations("", { force: true });

      this.payloadOrganization = { ...this.defaultPyloadOrganization };
      this.editedId = -1;
      this.dialogOrganization = true;

      if (this.$refs.formOrganization) this.$refs.formOrganization.reset();
    },

    async editItem(item) {
      this.countryList();

      const index = this.organizationsData.indexOf(item);
      if (index !== -1) {
        this.editedId = this.organizationsData[index].id;

        this.payloadOrganization = {
          ...item,
          organizationTypePrev: item.organizationType,
        };

        // reset
        this.parentOrgSearch = "";
        this.parentOrgLastQuery = "";
        this.allOrganizations = [];

        await this.fetchParentOrganizations(item.mainOrganization, {
          force: true,
        });

        this.getAllDocuments();
        this.getExeptionsList();
        this.getPredefinedGoodsList(this.getTableOptions("predefinedGoods"));
        this.getPredefinedReturnGoodsList(
          this.getTableOptions("predefinedReturnGoods")
        );
        this.getCarrierOrganizationsList(
          this.getTableOptions("carrierOrganizationsList")
        );
      }

      this.dialogOrganization = true;
    },

    deleteItem(item) {
      const index = this.organizationsData.indexOf(item);
      if (index !== -1) {
        confirm(this.$i18n.t("organization.delete_warning_message")) &&
          this.DELETE_ORGANIZATION({
            payload: this.organizationsData[index].id,
            payloadUpdate: this.payload,
          }).then((response) => {
            if (response.status === 200) {
              this.snackbar.text = this.$i18n.t(
                "organization.organizationDeleted"
              );
              this.snackbar.isShow = true;
            }
          });
      }
    },
    removeItem() {
      this.deleteDialog = false;
    },
    showSearchRow() {
      this.showSearch = true;
    },
    hideFilter() {
      this.showSearch = false;
      this.searchText = "";

      this.payload = this.payloadDefault();
      this.payload.Limit = this.options.itemsPerPage;
      this.GET_ORGANIZATION(this.payload);
    },
    search(e) {
      e.preventDefault();
      if (this.searchText.length > 0) {
        this.payload = this.payloadDefault();
        this.payload.Limit = this.options.itemsPerPage;
        this.payload.Search = this.searchText.trim();
        this.GET_ORGANIZATION(this.payload);
      }
    },
    payloadDefault() {
      return {
        Id: 0,
        name: "",
        street: "",
        postalCode: "",
        place: "",
        countryCode: "",
        organizationType: 0,
        Search: "",
        Page: 1,
        Limit: 10,
        OrderBy: "",
        Direction: "asc",
      };
    },
    resetFormOrganization() {
      this.dialogOrganization = false;
      this.$refs.formOrganization.reset();
      this.tab = 0;
      this.newExceptionType = "";
      this.translationExceptionTypes.forEach((item) => {
        item.name = "";
      });
      this.isShowCheckboxTranslationExceptionTypes = false;
      this.isShowTranslationExceptionTypes = false;
    },
    resetLogo() {
      this.documentFileInputLogo = null;
      this.documentFileIsLoadingLogo = false;
      this.documentFileLogo = "";
      this.documentFileNameLogo = "";
      this.documentFileErrorLogo = null;
      this.documentFileListLogo = [];
      this.documentFileIsUploadingLogo = false;
    },
    applyForm() {
      this.editedId === -1
        ? this.sendFormOrgsnisation()
        : this.editFormOrgsnisation();
    },

    isValidWebhookSettingsForm() {
      const webhookUrl = (this.payloadOrganization.webhookUrl || "").trim();
      const webhookAuthorization = (
        this.payloadOrganization.webhookAuthorization || ""
      ).trim();
      const cmrModifyWebhookUrl = (
        this.payloadOrganization.cmrModifyWebhookUrl || ""
      ).trim();
      const apiChangesNotificationEmail = (
        this.payloadOrganization.apiChangesNotificationEmail || ""
      ).trim();

      if (!this.isValidUrl(this.payloadOrganization.webhookUrl)) {
        this.tab = 1;
        this.snackbar.text = this.$i18n.t("organization.invalidURL");
        this.snackbar.isShow = true;
        return false;
      }
      if (!this.isValidUrl(this.payloadOrganization.cmrModifyWebhookUrl)) {
        this.tab = 1;
        this.snackbar.text = this.$i18n.t("organization.invalidCMRChangeURL");
        this.snackbar.isShow = true;
        return false;
      }

      if (
        webhookUrl !== "" &&
        !(
          this.payloadOrganization.webhookDriverSigningSign ||
          this.payloadOrganization.webhookSenderSigningSign ||
          this.payloadOrganization.webhookReadyToSigningSign ||
          this.payloadOrganization.webhookClosedSign
        )
      ) {
        this.tab = 1;
        this.snackbar.text = this.$i18n.t("organization.errorNotification1");
        this.snackbar.isShow = true;
        return false;
      }
      if (
        webhookUrl === "" &&
        (this.payloadOrganization.webhookDriverSigningSign ||
          this.payloadOrganization.webhookSenderSigningSign ||
          this.payloadOrganization.webhookReadyToSigningSign ||
          this.payloadOrganization.webhookClosedSign)
      ) {
        this.tab = 1;
        this.snackbar.text = this.$i18n.t("organization.errorNotification2");
        this.snackbar.isShow = true;
        return false;
      }
      if (
        webhookAuthorization !== "" &&
        cmrModifyWebhookUrl === "" &&
        webhookUrl === ""
      ) {
        this.tab = 1;
        this.snackbar.text = this.$i18n.t("organization.errorNotification3");
        this.snackbar.isShow = true;
        return false;
      }

      if (apiChangesNotificationEmail) {
        const validateEmails = (emails) => {
          const invalidEmails = [];
          const emailArr = emails.split(",");
          for (let i = 0; i < emailArr.length; i++) {
            const email = emailArr[i].trim();
            const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
            if (!regex.test(email)) {
              invalidEmails.push(email);
            }
          }
          return invalidEmails;
        };
        const isValidEmails = validateEmails(
          apiChangesNotificationEmail
        );
        if (isValidEmails.length) {
          this.tab = 1;
          this.snackbar.text = `${this.$i18n.t(
            "organization.invalidEmail"
          )}: ${isValidEmails.join(", ")}`;
          this.snackbar.isShow = true;
          return false;
        }
      }
      return true;
    },
    sendFormOrgsnisation() {
      if (this.$refs.formOrganization.validate()) {
        if (!this.isValidWebhookSettingsForm()) {
          return;
        }

        this.SET_ORGANIZATIONS({
          payloadCreate:
            this.payloadOrganization.organizationType !== 4
              ? { ...this.payloadOrganization, logo: this.documentFileLogo }
              : {
                  ...this.payloadOrganization,
                  ...this.emptyEmailSettings,
                  logo: this.documentFileLogo,
                }, //if Government type, clean email settings
          payloadUpdate: this.payload,
        }).then((response) => {
          if (response.status === 200) {
            this.snackbar.text = this.$i18n.t(
              "organization.organizationCreated"
            );
            this.snackbar.isShow = true;
          }
        });
        this.dialogOrganization = false;
        this.$refs.formOrganization.reset();
        this.tab = 0;
        this.resetLogo();
      } else {
        this.tab = 0;
      }
    },
    editFormOrgsnisation() {
      if (this.$refs.formOrganization.validate()) {
        if (!this.isValidWebhookSettingsForm()) {
          return;
        }

        this.UPDATE_ORGANIZATIONS({
          payloadUpdateForm:
            this.payloadOrganization.organizationType !== 4
              ? { ...this.payloadOrganization, logo: this.documentFileLogo }
              : {
                  ...this.payloadOrganization,
                  ...this.emptyEmailSettings,
                  logo: this.documentFileLogo,
                }, //if Government type, clean email settings
          payloadUpdate: this.payload,
        }).then((response) => {
          if (response.status === 200) {
            this.snackbar.text = this.$i18n.t(
              "organization.organizationUpdated"
            );
            this.snackbar.isShow = true;
          }
        });
        this.dialogOrganization = false;

        this.isErrorNewExceptionType = false;
        this.errorNewExceptionTypeMessage = "";

        this.isErrorAddEmail = false;
        this.errorMessageAddEmail = "";
        //this.$refs.formOrganization.reset();
        this.tab = 0;
        this.resetLogo();
      } else {
        this.tab = 0;
      }
    },
    // nextForm() {
    //     if (this.$refs.formOrganization.validate()) {
    //         this.tab = 1
    //     }
    // },
    close() {
      this.dialogOrganization = false;
      setTimeout(() => {
        this.payloadOrganization = { ...this.defaupPyloadOrganization };
        this.editedId = -1;
        this.tab = 0;
      }, 300);

      this.isErrorNewExceptionType = false;
      this.errorNewExceptionTypeMessage = "";

      this.isErrorAddEmail = false;
      this.errorMessageAddEmail = "";
    },

    parentOrgNoFilter() {
      return true;
    },

    setOrganizationType(parentId) {
      this.parentId = parentId;
    },

    isDisabledDeleteEdit() {
      return !this.$isPermitted("modifyOrDeleteOrganizations");
    },

    isDisabledCreate() {
      return !this.$isPermitted("createOrganizations");
    },

    sendDocument() {
      const payload = {
        organizationId: this.editedId,
        documentFile: this.documentFile,
        name: this.documentFileName,
        mailingInclusionSign: false,
      };
      this.documentFileIsUploading = true;
      Axios.post(
        config.apiBaseUrl + "api/organization/add-document",
        qs.stringify(payload),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.setDefaulteDocumentParams();
            this.getAllDocuments();
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.error(error.response.data);
          this.documentFileError = error.response.data;
        })
        .finally(() => {
          this.documentFileIsUploading = false;
        });
    },

    setDefaulteDocumentParams() {
      this.documentFileInput = null;
      this.documentFileIsLoading = false;
      this.documentFile = "";
      this.documentFileName = "";
      this.documentFileError = null;
    },

    getAllDocuments() {
      Axios.get(
        config.apiBaseUrl +
          `api/organization/document-list?organizationId=${this.editedId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.documentFileList = response.data;
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },

    deleteDoc(id) {
      Axios.get(
        config.apiBaseUrl + `api/organization/delete-document?id=${id}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            this.getAllDocuments();
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.log(error);
        });
    },
    handlerDocChange(e, doc) {
      const payload = {
        id: doc.id,
        mailingInclusionSign: e,
        organizationId: doc.organizationId,
      };
      Axios.post(
        config.apiBaseUrl + "api/organization/edit-document",
        qs.stringify(payload),
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            // this.setDefaulteDocumentParams();
            // this.getAllDocuments();
          }
        })
        .catch((error) => {
          if (error.sessionExpiryHandled) return;
          /* eslint-disable */
          console.error(error.response.data);
          this.documentFileError = error.response.data;
        });
    },

    getTableOptions(type) {
      let data = {};

      if (type === "predefinedGoods") {
        data.Page = this.optionsPredefinedGoodsList.page;
        data.Limit = this.optionsPredefinedGoodsList.itemsPerPage;
      }
      if (type === "predefinedReturnGoods") {
        data.Page = this.optionsPredefinedReturnGoodsList.page;
        data.Limit = this.optionsPredefinedReturnGoodsList.itemsPerPage;
      }
      if (type === "carrierOrganizationsList") {
        data.Page = this.optionsCarrierOrganizationsList.page;
        data.Limit = this.optionsCarrierOrganizationsList.itemsPerPage;
      }
      return data;
    },

    async fetchParentOrganizations(search, { force = false } = {}) {
      const q = (search || "").trim();

      if (
        !force &&
        q === this.parentOrgLastQuery &&
        this.allOrganizations.length
      ) {
        return;
      }

      this.parentOrgLastQuery = q;

      // 1) отменяем предыдущий запрос
      if (this.parentOrgAbort) {
        this.parentOrgAbort.abort();
      }
      const controller = new AbortController();
      this.parentOrgAbort = controller;

      // 2) увеличиваем счетчик запросов
      const reqId = ++this.parentOrgReqId;

      this.parentOrgLoading = true;

      try {
        const url =
          config.apiBaseUrl +
          `api/organization/parent?search=${encodeURIComponent(q)}`;

        const { data } = await Axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
          },
          signal: controller.signal,
        });

        // 3) если уже есть более новый запрос — игнорируем этот ответ
        if (reqId !== this.parentOrgReqId) return;

        const list = Array.isArray(data) ? data : data?.data || [];
        this.allOrganizations = list;
      } catch (e) {
        if (e.name === "CanceledError" || e.code === "ERR_CANCELED") return;

        console.log(e);
        this.allOrganizations = [];
      } finally {
        if (reqId === this.parentOrgReqId) {
          this.parentOrgLoading = false;
        }
      }
    },

    onParentOrgOpen() {
      if (!this.allOrganizations.length) {
        this.fetchParentOrganizations(this.parentOrgSearch || "");
      }
    },

    onParentOrgClear() {
      this.parentOrgSearch = "";
      this.parentOrgLastQuery = "";
      this.allOrganizations = [];

      this.fetchParentOrganizations("", { force: true });
    },

    // ----- end methods
  },
  watch: {
    parentOrgSearch(val) {
      if (this.parentOrgDebounceTimer)
        clearTimeout(this.parentOrgDebounceTimer);

      this.parentOrgDebounceTimer = setTimeout(() => {
        const q = (val || "").trim();

        if (q.length === 0) {
          this.fetchParentOrganizations("", { force: true });
          return;
        }

        if (q.length < 2) return;

        this.fetchParentOrganizations(q);
      }, 350);
    },

    "optionsPredefinedGoodsList.page"() {
      this.getPredefinedGoodsList(this.getTableOptions("predefinedGoods"));
    },

    "optionsPredefinedGoodsList.itemsPerPage"() {
      this.getPredefinedGoodsList(this.getTableOptions("predefinedGoods"));
    },

    "optionsPredefinedReturnGoodsList.page"() {
      this.getPredefinedReturnGoodsList(
        this.getTableOptions("predefinedReturnGoods")
      );
    },
    "optionsPredefinedReturnGoodsList.itemsPerPage"() {
      this.getPredefinedReturnGoodsList(
        this.getTableOptions("predefinedReturnGoods")
      );
    },

    "optionsCarrierOrganizationsList.page"() {
      this.getCarrierOrganizationsList(
        this.getTableOptions("carrierOrganizationsList")
      );
    },
    "optionsCarrierOrganizationsList.itemsPerPage"() {
      this.getCarrierOrganizationsList(
        this.getTableOptions("carrierOrganizationsList")
      );
    },
    "payloadOrganization.issuingOrganization"(v) {
      if (!v) {
        this.payloadOrganization.pdfLogRegistration = false;
      }
      if (!v && !this.canManualCreationUseSign) {
        this.payloadOrganization.manualCreationUseSign = false;
      }
    },
    newExceptionType(v) {
      if (
        this.translationExceptionTypes.some((item) => item.name.length > 0) &&
        !v.trim()
      ) {
        this.isErrorNewExceptionType = true;
        this.errorNewExceptionTypeMessage = this.$i18n.t(
          "organization.exceptionTypeError"
        );
        this.isShowTranslationExceptionTypes = false;
      } else {
        this.isErrorNewExceptionType = false;
        this.errorNewExceptionTypeMessage = "";
      }

      if (v.trim()) {
        this.isShowCheckboxTranslationExceptionTypes = true;
      } else {
        this.isShowCheckboxTranslationExceptionTypes = false;
        this.isShowTranslationExceptionTypes = false;
      }
    },
    translationExceptionTypes: {
      handler() {
        if (
          this.translationExceptionTypes.some((item) => item.name.length > 0) &&
          !this.newExceptionType.trim()
        ) {
          this.isErrorNewExceptionType = true;
          this.errorNewExceptionTypeMessage = this.$i18n.t(
            "organization.exceptionTypeError"
          );
          this.isShowTranslationExceptionTypes = false;
        } else {
          this.isErrorNewExceptionType = false;
          this.errorNewExceptionTypeMessage = "";
        }
      },
      deep: true,
    },
    "payloadOrganization.exceptionNotifyEmails"(v) {
      if (v || v === "") {
        this.exceptionEmails = v
          .split(",")
          .filter(Boolean)
          .map((email) => ({ name: email }));
      }
    },
    options: {
      handler() {
        this.$store.state.loading = true;
        this.payload.Page = this.options.page;
        this.payload.Limit = this.options.itemsPerPage;

        let sortByLength = this.options.sortBy.length;
        let sortDescLength = this.options.sortDesc.length;

        if (sortByLength > 0) {
          this.payload.OrderBy = this.options.sortBy[0];
        }

        if (sortDescLength > 0) {
          if (this.options.sortDesc[0]) {
            this.payload.Direction = "desc";
          }
        } else {
          this.payload.Direction = "asc";
        }

        this.GET_ORGANIZATION(this.payload);
      },
      deep: true,
    },
    dialogOrganization(val) {
      val || this.close();
    },

    payloadOrganization: {
      handler(val) {
        if (
          typeof val.organizationType !== "undefined" &&
          typeof val.organizationType.value !== "undefined"
        )
          this.payloadOrganization.organizationType = this.payloadOrganization.organizationType.value;
      },
      deep: true,
    },

    "payloadOrganization.organizationId"(v) {
      this.setOrganizationType(v);
    },

    "payloadOrganization.organizationType"(v) {
      this.isGovernment = v === 4;
    },
    documentFileInput(val) {
      this.documentFileError = null;
      if (val) {
        const $this = this;
        this.documentFileIsLoading = true;
        let reader = new FileReader();
        reader.readAsDataURL(val);
        reader.onload = function() {
          $this.documentFileIsLoading = false;
          $this.documentFile = reader.result.split("base64,")[1];
          $this.documentFileName = val.name;
        };
        reader.onerror = function() {
          $this.documentFileIsLoading = false;
        };
      } else {
        this.documentFileIsLoading = false;
        this.documentFile = "";
        this.documentFileName = "";
      }
    },
    documentFileInputLogo(val) {
      this.documentFileErrorLogo = null;
      if (val instanceof File) {
        const $this = this;
        this.documentFileIsLoadingLogo = true;
        const reader = new FileReader();

        reader.onload = function() {
          if (reader.result.includes("image")) {
            $this.documentFileIsLoadingLogo = false;
            $this.documentFileLogo = reader.result.split("base64,")[1];
            $this.documentFileNameLogo = val.name;
          } else {
            $this.documentFileErrorLogo = $this.$i18n.t(
              "organization.errorLogo"
            );
          }
        };
        reader.onerror = function() {
          $this.documentFileIsLoadingLogo = false;
        };
        reader.readAsDataURL(val);
      } else {
        this.documentFileIsLoadingLogo = false;
        this.documentFileLogo = "";
        this.documentFileNameLogo = "";
        this.documentFileErrorLogo = null;
      }
    },
  },
};
</script>
